// D12 (28 Sep 2026): every slider looks for its own pagination and arrows inside itself (this.querySelector).
// With page-wide selectors, a one-photo gallery locked and hid the announcement bar arrows.
class productslider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = $(this);
      $(this2).css({ opacity: "1" });
      $(this2).css({ visibility: "visible" });

      var swiper = new Swiper(
        ".product-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-slider", productslider);

class bundleslider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = $(this);
      $(this2).css({ opacity: "1" });
      $(this2).css({ visibility: "visible" });
   
      var swiper = new Swiper(
        ".bundle-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("bundle-slider", bundleslider);

class customTextIcon extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };

    if ($(window).width() > 990) {
      var swiper = new Swiper(".tai-icon-man-box", {
        slidesPerView: "5",
        spaceBetween: 20,
        freeMode: true,
      });
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-text-icon", customTextIcon);




class productgalleryhux extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    // Audit D2 (28 Sep 2026): on phones the element itself is display:contents (so the buy box can sit between photo and icons),
    // which gives it no box to observe, so watch the photo wrapper instead.
    const target = this.querySelector(':scope > .product-gallery-hux') || this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(target);
      // Round 4 (29 Sep 2026): the pending class always comes off, even if jQuery or Swiper throws. Without Swiper the snippet's inline rules still show the first slide and the thumbnail row.
      this.classList.remove("hux-gallery-pending");
      try {
      this.style.opacity = "1";
      this.style.visibility = "visible";

      var swiper = new Swiper(".thumbnail-product-slider-huxx--" + this.getAttribute("data-sectionid"), {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        direction: "horizontal",
        breakpoints: { 
          769: { 
        direction: "vertical",
        spaceBetween: 20,
          }, 
        },
      });
    var swiper2 = new Swiper(".product-slider-huxx--" + this.getAttribute("data-sectionid"), {
      spaceBetween: 10,
      grabCursor: true,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      thumbs: {
        swiper: swiper,
      },
    });
      } catch (e) {
        console.error("product-gallery-hux: slider failed to start", e);
      } finally {
        this.classList.remove("hux-gallery-pending");
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(target);
  }
}
customElements.define("product-gallery-hux", productgalleryhux);


class imagewithtextslider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = $(this);
      $(this2).css({ opacity: "1" });
      $(this2).css({ visibility: "visible" });

      var swiper = new Swiper(
        ".image-with-text-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          loop: true,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },  
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("image-with-text-slider", imagewithtextslider);


class imagewithfaq extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            $(".custom-card-main").find(".faq-answers").removeClass("show");
            $(".custom-card-main").find(".faq-answers").slideUp(350);
            $(".custom-card-main").removeClass("active");

            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $(".custom-card-main")
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");

            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
          // if ($this.parent().hasClass('active')) {
          //     $this.parent().removeClass('active');
          // } else {
          //     $('.custom-card-main').find('.custom-card-main').removeClass('active');
          //     $this.parent().toggleClass('active');
          // }
        }
      );
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("image-with-faq", imagewithfaq);

class iconwithtext extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = $(this);
      $(this2).css({ opacity: "1" });
      $(this2).css({ visibility: "visible" });

      var swiper = new Swiper(
        ".icon-with-text-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1100: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("icon-with-text", iconwithtext);
